/******/ (() => { // webpackBootstrap
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "observer");
    this.isLoaded = false;
    this.loadRecommendations = this.loadRecommendations.bind(this);
  }
  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }
  initializeRecommendations(productId) {
    var _a;
    (_a = this.observer) == null ? void 0 : _a.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }
  loadRecommendations(productId) {
    if (this.isLoaded) return;
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`).then((response) => response.text()).then((text) => {
      this.isLoaded = true;
      this.innerHTML = text;
    }).catch((e) => {
      console.error(e);
    });
  }
}
customElements.define("product-recs", ProductRecommendations);

/******/ })()
;